import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index'
import routes_user from './routes_user'
import routes_campaigns from './routes_campaigns'
import routes_combat from './routes_combat'
import routes_catchall from './routes_catchall'
import routes_characters from './routes_characters'
//--------
// router
//--------
const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    ...routes_user,
    ...routes_campaigns,
    ...routes_characters,
    ...routes_combat,
    ...routes_catchall,
  ],
})
//------------
// beforeEach
//------------
router.beforeEach(async (to) => {
  await store.dispatch('auth/ensureAuthState')

  const isAuthenticated = store.getters['auth/isAuthenticated']
  const requiresAuth = to.matched.some((route) => route.meta && route.meta.requiresAuth)

  // NOT authenticated + root path => login
  if (!isAuthenticated && to.fullPath === '/') {
    return redirectToLogin(to)
  }
  // NOT authenticated + path req auth => login
  if (!isAuthenticated && requiresAuth) {
    return redirectToLogin(to)
  }

  // set page title
  // var title = "";
  // if (to.params.type) {
  //   title = to.params.type + " Characters View";
  // } else {
  // title = to.meta.title;
  // }
  store.commit('auth/setPageTitle', to.meta.title)
  // store.commit("auth/setPageTitle", title);

  // IS authenticated + root path => home
  if (to.fullPath === '/') {
    return redirectToHome(to)
  }

  return true
})
//-----------------
// redirectToLogin
//-----------------
const redirectToLogin = (route) => {
  const login = 'loginView'
  if (route.name != login) {
    return {
      name: login,
      replace: true,
      // query: { redirectFrom: route.fullPath },
    }
  }
}
//----------------
// redirectToHome
//----------------
const redirectToHome = () => {
  const mydefault = 'campaignsView'
  return { name: mydefault, replace: true }
}
//---------------
// export router
//---------------
export default router
